<template>
    <div>
        <div v-if="content">
          <h3 id="title">{{ content.title }}</h3>

          <h4 id="type">{{ content.contentType.name }} / {{ content.contentCategory.name }}</h4>

          <div id="description" v-html="decodedContentDescription"></div>
        </div>
    </div>
</template>

<script>
import contentApi from "../../api/content";
import { mapState } from "vuex";
import html from "js-htmlencode";

export default {
  data() {
    return {
      content: null
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    decodedContentDescription: function() {
      if (this.content) {
        return html.htmlDecode(this.content.description);
      }
      return "";
    }
  },

  props: {
    id: {
      required: true
    }
  },

  created() {
    var that = this;

    contentApi
      .getContentById(this.id)
      .then(function(response) {
        that.content = response.data;
        contentApi.createContentView(that.id).catch(function(error) {
          console.log(error);
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
